import styled from 'styled-components';

export const Title = styled.h4`
  font-size: 2rem;
  margin: 0 0 ${props => props.theme.margin};
  text-align: center;
`;

export const ErrorList = styled.div`
  margin: 3em ${props => props.theme.margin};
`;

export const TextInputError = styled.span`
  display: block;
  color: ${props => props.theme.checkoutPage.requiredMessageColor};
  font-size: 1.6rem;
  font-weight: normal;
  margin: ${props => props.theme.margin} 0;
`;



// WEBPACK FOOTER //
// ./components/CheckoutErrorModal/CheckoutErrorModal.style.js